import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  private themeConfig$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private loadingThemeConfig$ = new BehaviorSubject<boolean>(true);
  public themeConfig = this.themeConfig$.asObservable();
  public loadingThemeConfig = this.loadingThemeConfig$.asObservable();

  private tenantAppThemeConfig$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private loadingTenantAppThemeConfig$ = new BehaviorSubject<boolean>(true);
  public tenantAppThemeConfig = this.tenantAppThemeConfig$.asObservable();
  public loadingTenantAppThemeConfig = this.loadingTenantAppThemeConfig$.asObservable();

  private toggleSidebarMenu$ = new BehaviorSubject<boolean>(false);
  public toggleSidebarMenu = this.toggleSidebarMenu$.asObservable();

  private orgId: number | null = null;
  orgIdData = new ReplaySubject<any>(1);

  private headerShown = true;
  private footerShown = true;
  sideBarState = new Subject<boolean>();
  navBarStatus = new Subject<boolean>();

  private shouldShowNavBarContents = false;

  constructor(private http: HttpClient) { }

  showNavBar() {
    this.shouldShowNavBarContents = true;
    this.navBarStatus.next(this.shouldShowNavBarContents);
  }

  hideNavBar() {
    this.shouldShowNavBarContents = false;
    this.navBarStatus.next(this.shouldShowNavBarContents);
  }

  showSideBar() {
    this.sideBarState.next(true);
  }

  hideSideBar() {
    this.sideBarState.next(false);
  }

  setDefaultHeaderAndFooterState() {
    this.footerShown = true;
    this.headerShown = true;
  }

  isFooterShown() {
    return this.footerShown;
  }

  isHeaderShown() {
    return this.headerShown;
  }

  hideFooter() {
    this.footerShown = false;
  }

  showFooter() {
    this.footerShown = true;
  }

  hideHeader() {
    this.headerShown = false;
  }

  showHeader() {
    this.headerShown = true;
  }


  public setThemeConfig(theme: any) {
    this.themeConfig$.next(theme);
  }

  public setThemeConfigLoading(status: boolean) {
    this.loadingThemeConfig$.next(status);
  }

  public setTenantAppThemeConfig(theme: any) {
    this.tenantAppThemeConfig$.next(theme);
  }

  public setTenantAppThemeConfigLoading(status: boolean) {
    this.loadingTenantAppThemeConfig$.next(status);
  }

  public setSidebarMenuState(state: boolean) {
    this.toggleSidebarMenu$.next(state);
  }

  public setOrgId(orgId: number) {
    this.orgId = orgId;
    this.orgIdData.next(this.orgId);
  }

  /* GET ORGANISATION DETAILS*/
  getOrganisationDetailsForTheme(value: any, name = 'id'): Observable<any> {
    return this.http.get(
      `/superadmin/organisations/get-organisation-details-theme?${name}=${value}`
    );
  }

}
